import { PromoCode } from "@interfaces/admin/promoCode";
import { authApi } from "@RTKQuery/basic";

const promoCodesAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getAllPromoCodes: build.query<{
            promo_codes: PromoCode[],
            count_items: number
        }, {
            page: number
        }>({
            query: ({ page }) => ({
                url: "promo_codes",
                params: {
                    page,
                    size: 50
                }
            }),
            providesTags: ["PromoCodeAdmin"]
        }),
        createPromoCode: build.mutation<PromoCode, Pick<PromoCode, "code" | "type" | "bonus" | "quantity">>({
            query: (body) => ({
                url: "promo_codes",
                method: "POST",
                body
            }),
            invalidatesTags: ["PromoCodeAdmin"]
        }),
        deletePromoCode: build.mutation<PromoCode, {
            promo_code_id: PromoCode["id"],
            page: number
        }>({
            query: ({ promo_code_id }) => ({
                url: "promo_codes/" + promo_code_id,
                method: "DELETE",
            }),
            async onQueryStarted({ page, promo_code_id }, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled

                    dispatch(promoCodesAuthApi.util.updateQueryData("getAllPromoCodes", { page }, (draft) => {
                        return {
                            count_items: draft.count_items - 1,
                            promo_codes: draft.promo_codes.filter(item => item.id !== promo_code_id)
                        }
                    }))
                } catch { }
            },
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetAllPromoCodesQuery,
    useCreatePromoCodeMutation,
    useDeletePromoCodeMutation
} = promoCodesAuthApi;